import { Helmet } from "react-helmet-async";
import { getRouteMeta, SITE_URL } from "../seo/routes-meta";
import { getContentSeo } from "../lib/content";

// Le composant lit la SOURCE UNIQUE (src/seo/routes-meta.js).
// Précédence : surcharge admin > routes-meta (routes publiées) > props de la page.
export default function Seo({ path, routeKey, title, description, image, jsonLd, noCanonical }) {
  const meta = getRouteMeta(path || routeKey || "/");
  const ov = (getContentSeo() && getContentSeo()[meta.matchKey]) || {};

  const t = ov.title || meta.title || title || "VIRALYA";
  const d = ov.description || meta.description || description || "";
  const img = ov.image || image || meta.ogImage;
  const ogT = meta.ogTitle || t;
  const ogD = meta.ogDescription || d;
  const lds = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{t}</title>
      <meta name="description" content={d} />
      {!noCanonical && <link rel="canonical" href={meta.canonical} />}
      <meta name="robots" content={meta.noindex ? "noindex, nofollow" : "index, follow"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="VIRALYA" />
      <meta property="og:locale" content="fr_CH" />
      <meta property="og:title" content={ogT} />
      <meta property="og:description" content={ogD} />
      <meta property="og:url" content={meta.canonical} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogT} />
      <meta name="twitter:description" content={ogD} />
      <meta name="twitter:image" content={img} />
      {lds.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}

export { SITE_URL };
